<!--&================= TITLE COMPONENT =================&-->
<div class="title-components">
  <h1>Reportes estructurados</h1>
</div>

<!--&================= CONTAINER CARD OPTION REPORT =================&-->
<div class="Content-Tasks">
  <ng-container *ngFor="let Library of AllReports">
    <ng-container *ngIf="UserService.UserRoleGeneralIn(Library.Roles)">
      <ng-container *ngFor="let Library_Report of Library.Library">
        <div
          *ngIf="UserService.UserRoleGeneralIn(Library_Report.Roles)"
          class="Card-Task"
        >
          <div class="Content-Card">
            <div class="Card-Notification">
              <div class="notifications button-square">
                <i class="fa-solid fa-chart-pie"></i>
              </div>
            </div>
            <div class="Body-Card">
              <div class="Title-Card">
                <h2>{{ Library_Report.Library }}</h2>
              </div>
              <div class="Subtitle-Card">
                {{ GetGreeting() }}, {{ NameUser() }},
                {{ Library_Report.Description }}
              </div>
            </div>
          </div>
          <div class="Btn-See-Task">
            <button
              [disabled]="!UserService.UserRoleGeneralIn(Library_Report.Roles)"
              [class.Is-Disabled]="!UserService.UserRoleGeneralIn(Library_Report.Roles)"
              routerLink="{{ Library_Report.RouteLink }}"
              class="Btn-Task btn-icon-text-left"
            >
              <span class="text">{{
                UserService.UserRoleGeneralIn(Library_Report.Roles)
                  ? 'Ver Reporte'
                  : 'Sin Permisos'
              }}</span
              ><i class="fa-solid fa-chart-simple"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
